<template>
    <v-dialog v-model="show" hide-overlay persistent max-width="80%">
        <v-card>
            <div class="pl-3 pt-3">
                <span style="font-weight: bold; font-size: larger;" >File</span>
                <v-btn icon style="float: right;" @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text>
                <div style="display: block;">
                </div>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-file-input @change="fileChange" accept="audio/ogg"
                                      placeholder="Select a ost file"
                                      label="File"
                                      ref="fileUpload"
                                      outlined></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field label="File Name" v-model="fileToAdd.name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <header-text class="ml-3" title="Size" :text="fileToAdd.size"></header-text>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <header-text class="ml-3" title="Length" :text="fileToAdd.length"></header-text>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <div class="ml-3 mt-3"><h2>Unsaved meta</h2></div>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <header-text class="ml-3" title="Album" :text="fileToAdd.album"></header-text>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <header-text class="ml-3" title="Artist" :text="fileToAdd.artist"></header-text>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <header-text class="ml-3" title="Tracks" :text="fileToAdd.tracks"></header-text>
                    </v-col>
                </v-row>
            </v-card-text>
            <div style="text-align: center;" class="pb-3">
                <v-btn @click="upload()" v-if="!uploaded"> Upload</v-btn>
                <v-btn @click="close()" v-if="uploaded"> Done</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import HeaderText from '../HeaderText'
    import {FileService, CommonService} from '../../services'

    export default {
        name: "NewFileDialog",
        components: {
            HeaderText
        },
        props: ['editFile', 'show'],
        created() {
            this.initialize()
        },
        data: () => ({
            uploaded: false,
            fileToAdd: null,
            defaultFile: {
                ostFile: null,
                parseItem:null,
                name: '',
                size: 0,
                length: '',
                artist: '',
                album: '',
                tracks: 0
            }
        }),

        computed:{
        },

        methods: {
            initialize() {
                this.fileToAdd = Object.assign({},this.defaultFile);
            },
            fileChange(ost) {
                if (ost === undefined) {
                    this.fileToAdd = Object.assign({},this.defaultFile);
                } else {
                    this.showLoading(true);
                    this.fileToAdd.name = ost.name;
                    this.fileToAdd.ostFile = ost;
                    this.fileToAdd.size = ost.size;

                    FileService.ostMeta(ost).then(meta => {
                        this.fileToAdd.length = meta.format.duration;
                        this.fileToAdd.album = FileService.getAlbum(meta);
                        this.fileToAdd.artist = FileService.getArtist(meta);
                        this.fileToAdd.tracks = FileService.getTracks(meta);
                    }).finally(() => {
                        this.showLoading(false);
                    });

                }
            },
            upload(){
                this.$emit('fileUploaded', this.fileToAdd);
            },
            bytesToSize(bytes) {
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes === 0) return 'n/a';
                const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
                if (i === 0) return `${bytes} ${sizes[i]}`;
                return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
            },

            close() {
                this.fileToAdd = Object.assign({},this.defaultFile);
                this.$emit('closeDialog')
            },
            showLoading(b) {
                CommonService.showLoading(b);
            }
        }
    }
</script>

<style scoped>

</style>